import { render, staticRenderFns } from "./BaseFieldNumber.vue?vue&type=template&id=165be747&scoped=true"
import script from "./BaseFieldNumber.vue?vue&type=script&lang=js"
export * from "./BaseFieldNumber.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldNumber.vue?vue&type=style&index=0&id=165be747&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165be747",
  null
  
)

export default component.exports